/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Dataset_CurrencyInputs */

const en_reference_dataset_currency = /** @type {(inputs: Reference_Dataset_CurrencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Currencies`)
};

/**
* | output |
* | --- |
* | "Currencies" |
*
* @param {Reference_Dataset_CurrencyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_dataset_currency = /** @type {((inputs?: Reference_Dataset_CurrencyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Dataset_CurrencyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_dataset_currency(inputs)
});